<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="md:tw-w-1/3">
          <fieldset class="tw-h-full">
            <legend>
              {{ legends + "planSpecifications" | translate }}
            </legend>

            <!-- name -->
            <div class="tw-w-full">
              <form-field
                [(value)]="model.name"
                [control]="form?.get('name')"
                [label]="'common.name' | translate"
              >
              </form-field>
            </div>

            <!-- planType -->
            <div class="tw-w-full">
              <enum-select-search
                enumName="PlanType"
                label="common.type"
                [control]="form?.get('planType')"
                [value]="model.planType"
                (valueChange)="onChangeType($event)"
                (onError)="onClose()"
              >
              </enum-select-search>
            </div>

            <!-- price -->
            <div class="tw-w-full">
              <form-field
                [(value)]="model.price"
                [hasCurrency]="true"
                type="tel"
                [hasNumberSeparator]="true"
                [control]="form?.get('price')"
                [label]="'common.price'"
              >
              </form-field>
            </div>

            <!-- expirationTime -->
            <div class="tw-w-full" *ngIf="model.planType == 2">
              <app-date-time-picker
                [config]="dateTimeConfig"
                (dateTime)="model.expirationTime = $event"
              >
              </app-date-time-picker>
            </div>

            <!-- isDefault -->
            <div *ngIf="model.planType == 2" class="sm:tw-w-1/2 xl:tw-w-1/3 tw-py-2">
              <mat-slide-toggle
                formControlName="isDefault"
                [(ngModel)]="model.isDefault"
              >
                {{ "common.isDefault" | translate }}
              </mat-slide-toggle>
            </div>
          </fieldset>
        </div>

        <div class="md:tw-w-2/3">
          <fieldset class="tw-h-full">
            <legend>
              {{ legends + "modules" | translate }}
            </legend>

            <app-plan-menus
              [menus]="menus"
              [isEditMode]="formPageConfig.isEditMode"
              [selectedMenuIds]="selectedMenuIds"
              (selectedMenuIds)="this.model.menuIds = $event"
            >
            </app-plan-menus>
          </fieldset>
        </div>
      </div>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
